/* NSC : options de personnalisation du produit (remplace Globo Product Options)
   - <nsc-options> lit les choix du client, valide les champs obligatoires et affiche le récapitulatif.
   - product-form.js appelle collect() puis buildItems() pour ajouter au panier le produit
     (avec ses choix en propriétés) + une ligne « produit d'option » pour chaque choix payant. */
if (!customElements.get('nsc-options')) {
  customElements.define(
    'nsc-options',
    class NscOptions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.formId = this.dataset.form;
        this.base = parseInt(this.dataset.basePrice, 10) || 0;
        this.freeShipping = parseInt(this.dataset.freeShipping, 10) || 0;
        this.productTitle = this.dataset.productTitle || '';
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        });
        this.groups = Array.from(this.querySelectorAll('[data-nsc-group]'));
        this.totalValueEl = this.querySelector('[data-nsc-total-value]');
        this.linesEl = this.querySelector('[data-nsc-lines]');
        this.qtyLabelEl = this.querySelector('[data-nsc-qty]');
        this.goalEl = this.querySelector('[data-nsc-goal]');
        this.globalError = this.querySelector('[data-nsc-global-error]');

        this.addEventListener('change', (event) => this.onChange(event));
        this.addEventListener('input', (event) => this.onChange(event));
        this.addEventListener('click', (event) => this.onClick(event));

        // Livraison programmée : pas de date dans le passé
        const today = new Date();
        const iso = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
        this.querySelectorAll('input[type="date"]').forEach((input) => input.setAttribute('min', iso));

        // Quantité du produit : le total en dépend
        this.qtyInput = document.getElementById('Quantity-' + this.dataset.section);
        if (this.qtyInput) {
          this.qtyInput.addEventListener('change', () => this.refresh());
          this.qtyInput.addEventListener('input', () => this.refresh());
        }

        // Changement de variante : le prix de base change
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data && event.data.variant;
            if (variant && typeof variant.price === 'number') {
              this.base = variant.price;
              this.refresh();
            }
          });
        }

        // « Acheter maintenant » : le bouton du thème ne connaît pas les options, on le remplace par notre propre envoi
        this.buyNowHandler = (event) => {
          const button = event.target.closest && event.target.closest('.shopify-payment-button__button');
          if (!button) return;
          const form = document.getElementById(this.formId);
          const productForm = form && form.closest('product-form');
          if (!productForm || !productForm.contains(button)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.buyNow(form, productForm);
        };
        document.addEventListener('click', this.buyNowHandler, true);

        this.refresh();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.buyNowHandler) document.removeEventListener('click', this.buyNowHandler, true);
      }

      onChange(event) {
        const group = event.target.closest && event.target.closest('[data-nsc-group]');
        if (group) this.setInvalid(group, false);
        if (this.globalError) this.globalError.hidden = true;
        this.refresh();
      }

      // Permet de décocher une pastille « une seule réponse » quand elle n'est pas obligatoire
      onClick(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
        const group = input.closest('[data-nsc-group]');
        if (!group || group.dataset.required === 'true') return;
        if (group.nscLast === input) {
          input.checked = false;
          group.nscLast = null;
          this.setInvalid(group, false);
          this.refresh();
        } else {
          group.nscLast = input;
        }
      }

      setInvalid(group, invalid) {
        group.classList.toggle('is-invalid', invalid);
        const error = group.querySelector('.nso-group__error');
        if (error) error.hidden = !invalid;
      }

      formatDate(value) {
        return /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value) ? value.split('-').reverse().join('/') : value;
      }

      // « Paillettes : Paillettes » -> « Paillettes : Oui » (la valeur répète le nom du groupe)
      sameText(a, b) {
        const clean = (t) => String(t).toLowerCase().replace(/[‘’`]/g, "'").replace(/\s+/g, ' ').trim();
        return clean(a) === clean(b);
      }

      // Lit un groupe : { label, title, kind, values[], items[{text, price}], extras[{id, price, label, value}] }
      readGroup(group) {
        const kind = group.dataset.kind;
        const label = group.dataset.label;
        const title = group.dataset.title || label;
        const values = [];
        const items = [];
        const extras = [];
        const add = (el, text) => {
          const id = parseInt(el.dataset.variant, 10);
          const price = parseInt(el.dataset.price, 10) || 0;
          values.push(text);
          items.push({ text, price: id && price > 0 ? price : 0 });
          if (id && price > 0) extras.push({ id, price, label, value: text });
        };

        if (kind === 'select') {
          const select = group.querySelector('select');
          if (select) {
            const option = select.selectedOptions[0];
            if (option && option.value) add(option, option.value);
          } else {
            const checked = group.querySelector('input:checked');
            if (checked) add(checked, checked.value);
          }
        } else if (kind === 'swatch' || kind === 'swatch_multi') {
          group.querySelectorAll('input:checked').forEach((input) => {
            add(input, this.sameText(input.value, label) ? 'Oui' : input.value);
          });
        } else if (kind === 'text' || kind === 'textarea') {
          const field = group.querySelector('input, textarea');
          const text = field.value.trim();
          if (text) add(group, text);
        } else if (kind === 'date') {
          const value = group.querySelector('input').value;
          if (value) {
            const text = this.formatDate(value);
            values.push(text);
            items.push({ text, price: 0 });
          }
        }
        return { label, title, kind, values, items, extras };
      }

      // Lit tous les choix. Si report est vrai, affiche les erreurs et amène au premier champ manquant.
      collect(report) {
        const properties = {};
        const extras = [];
        let firstInvalid = null;

        this.groups.forEach((group) => {
          const result = this.readGroup(group);
          const invalid = group.dataset.required === 'true' && result.values.length === 0;
          if (report) this.setInvalid(group, invalid);
          if (invalid && !firstInvalid) firstInvalid = group;
          if (result.values.length) properties[result.label] = result.values.join(', ');
          extras.push(...result.extras);
        });

        if (report) {
          if (this.globalError) this.globalError.hidden = !firstInvalid;
          if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const focusable = firstInvalid.querySelector('select, input:not([type="radio"]):not([type="checkbox"]), textarea');
            if (focusable) focusable.focus({ preventScroll: true });
          }
        }
        return { properties, extras, invalid: Boolean(firstInvalid) };
      }

      // Propriétés déjà présentes dans le formulaire du produit (ex. carte cadeau) + quantité
      mainItemFromForm(form) {
        const formData = new FormData(form);
        const properties = {};
        formData.forEach((value, key) => {
          if (key.startsWith('properties[') && key.endsWith(']') && value !== '') {
            properties[key.slice(11, -1)] = value;
          }
        });
        return {
          id: Number(formData.get('id')),
          quantity: parseInt(formData.get('quantity'), 10) || 1,
          properties,
        };
      }

      async buyNow(form, productForm) {
        if (this.buying) return;
        if (this.collect(true).invalid) return;
        this.buying = true;
        const errorBox = productForm.querySelector('.product-form__error-message-wrapper');
        const errorText = errorBox && errorBox.querySelector('.product-form__error-message');
        if (errorBox) errorBox.hidden = true;
        try {
          const items = this.buildItems(this.mainItemFromForm(form));
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const json = await response.json();
          if (json.status) throw new Error(json.description || json.message);
          window.location.href = (window.routes && window.routes.root_url ? window.routes.root_url : '/') + 'checkout';
        } catch (error) {
          this.buying = false;
          if (errorBox && errorText) {
            errorText.textContent = error.message || 'Impossible de continuer, réessayez.';
            errorBox.hidden = false;
          }
        }
      }

      quantity() {
        return this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;
      }

      money(cents) {
        return this.formatter.format(cents / 100);
      }

      // Montant rond sans les décimales (« 210 € »)
      moneyShort(cents) {
        return cents % 100 === 0
          ? new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: this.dataset.currency || 'EUR', maximumFractionDigits: 0 }).format(cents / 100)
          : this.money(cents);
      }

      refresh() {
        const results = this.groups.map((group) => ({ group, data: this.readGroup(group) }));
        const extrasTotal = results.reduce((sum, r) => r.data.extras.reduce((s, e) => s + e.price, sum), 0);
        const qty = this.quantity();
        const total = (this.base + extrasTotal) * qty;

        this.updateTags(results);
        this.updateMonogram(results);
        this.updateCounters();
        this.updateRecap(results, total, qty);
      }

      // Titres de rubrique « vivants » : nom de la pastille choisie, nombre de suppléments
      updateTags(results) {
        this.querySelectorAll('[data-nso-tag][data-live]').forEach((tag) => {
          const entry = results.find((r) => r.group.id === tag.dataset.group);
          const count = entry ? entry.data.values.length : 0;
          let text = tag.dataset.default;
          if (count) {
            text = tag.dataset.live === 'count' ? count + (count > 1 ? ' choisis' : ' choisi') : entry.data.values.join(', ');
          }
          tag.textContent = text;
          tag.classList.toggle('is-live', count > 0);
        });
      }

      // Grand cercle avec l'initiale saisie
      updateMonogram(results) {
        results.forEach(({ group, data }) => {
          if (group.dataset.monogram !== 'true') return;
          const mono = group.querySelector('[data-nso-mono]');
          if (!mono) return;
          const first = (data.values[0] || '').trim().charAt(0);
          mono.textContent = first ? first.toUpperCase() : '·';
        });
      }

      updateCounters() {
        this.querySelectorAll('[data-nso-count]').forEach((counter) => {
          const field = counter.closest('[data-nsc-group]').querySelector('textarea');
          if (field) counter.textContent = field.value.length;
        });
      }

      // Récapitulatif chiffré : produit, chaque choix, total et message de livraison
      updateRecap(results, total, qty) {
        if (!this.linesEl) return;
        const lines = [{ label: this.productTitle, price: this.money(this.base) }];

        results.forEach(({ data }) => {
          if (!data.values.length) return;
          if (data.kind === 'swatch_multi') {
            data.items.forEach((item) => lines.push({ label: item.text, price: item.price > 0 ? this.money(item.price) : 'Offert' }));
          } else if (data.kind === 'select' || data.kind === 'swatch') {
            const item = data.items[0];
            lines.push({ label: data.label + ' : ' + item.text, price: item.price > 0 ? this.money(item.price) : 'Inclus' });
          } else if (data.kind === 'date') {
            lines.push({ label: data.title + ' : ' + data.items[0].text, price: '' });
          } else {
            const item = data.items[0];
            lines.push({ label: data.label + ' : ' + item.text, price: item.price > 0 ? this.money(item.price) : '' });
          }
        });

        const fragment = document.createDocumentFragment();
        lines.forEach((line) => {
          const row = document.createElement('div');
          row.className = 'nso-recap__line';
          const left = document.createElement('span');
          left.textContent = line.label;
          left.title = line.label;
          const right = document.createElement('span');
          right.textContent = line.price;
          row.append(left, right);
          fragment.append(row);
        });
        this.linesEl.replaceChildren(fragment);

        if (this.totalValueEl) this.totalValueEl.textContent = this.money(total);
        if (this.qtyLabelEl) this.qtyLabelEl.textContent = qty > 1 ? ' (× ' + qty + ')' : '';
        if (this.goalEl) {
          if (this.freeShipping > 0) {
            this.goalEl.hidden = false;
            this.goalEl.textContent = total >= this.freeShipping ? 'Livraison offerte' : 'Livraison offerte dès ' + this.moneyShort(this.freeShipping);
          } else {
            this.goalEl.hidden = true;
          }
        }
      }

      // Construit la liste des lignes à envoyer à /cart/add.js : produit principal + lignes d'options.
      buildItems(mainItem) {
        const data = this.collect(false);
        const quantity = mainItem.quantity;
        const properties = Object.assign({}, mainItem.properties, data.properties);
        const items = [];

        if (data.extras.length) {
          const token = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
          properties._nsc_group = token;
          data.extras.forEach((extra) => {
            const extraProps = { _nsc_parent: token };
            extraProps[extra.label] = extra.value;
            items.push({ id: extra.id, quantity, properties: extraProps });
          });
        }
        return [Object.assign({}, mainItem, { properties }), ...items];
      }
    }
  );
}
